/* eslint-disable import/prefer-default-export */
export const getShopLink = (order = null) => (order?.web_id
  ? `${ENV.SHOPS_BASE_URL}/checkout?order=${order.web_id}`
  : `${ENV.SHOPS_BASE_URL}/checkout`);
